angular.module('ui.order.orderItemsGrid', [])

    .directive('orderItemsGrid', function () {
        return {
            restrict: "E",
            templateUrl: 'app/ui/order/orderItemsGridView/orderItemsGrid/orderItemsGrid.html',
            scope: {},
            controller: 'OrderItemsGridController',
            controllerAs: 'OrderItemsGridController'
        };
    })

    .controller('OrderItemsGridController', function ($scope, $element, $compile, $q, $log, $state, gettextCatalog, toastr, $customisationConfig, usersRepository,
                                                      serverLocalization, uiLocalization, customResourceResolver,
                                                      workflowRepository, orderItemsGridSharedSettings, reportManager,
                                                      gridDataProvider, templateResolver, orderItemsGridControllerUpdatesService) {

        $scope.selectedOrderItem = null;
        $scope.selectedOrderItemId = null;
        $scope.showStepDetails = showStepDetails;
        $scope.getSelectedEntities = getSelectedEntities;
        $scope.applyTextSearch = applyTextSearch;
        $scope.reloadGrid = reloadGrid;

        initController();
        initWatchers();

        /**
         * Controller initialization
         */
        function initController() {
            $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';

            //clear any remembered search filter for 'All Items' view if 
            //it's not the searching from the main app header searchbox
            if ($scope.step == 'all-open' && !$state.params.search) {
                orderItemsGridSharedSettings.setTextSearch(null);
            }

            initAdditionalFilter();
            initTitle();
            initGrid();
            initReportList();
        }

        function initAdditionalFilter() {
            $scope.searchDropdownOptions = {
                dataSource: [
                    {text: gettextCatalog.getString("Regular Search"), value: "reg-search", icon: "fa fa-search-plus"},
                    {text: gettextCatalog.getString("Exact Match Search"), value: "exact-search", icon: "fa fa-search"}
                ],
                valuePrimitive: false,
                dataTextField: "text",
                dataValueField: "value",
                valueTemplate: ' ',
                template: '<span class="k-state-default"><i class="{{dataItem.icon}} pull-left"></i>' +
                '<span>{{dataItem.text}}</span></span>',
                dataBound: function () {
                    this.list.width("auto");
                }
            };

            $scope.clearSearchTerm = function () {
                orderItemsGridSharedSettings.setTextSearch(null);
                $scope.textSearch = null;
                applyTextSearch();
            };

            var textSearchConfig = orderItemsGridSharedSettings.getTextSearch();
            if (textSearchConfig) {
                $scope.textSearch = textSearchConfig.text;
                $scope.searchDropdown = textSearchConfig.exact ? "exact-search" : "reg-search";
            } else {
                $scope.textSearch = null;
                $scope.searchDropdown = "reg-search";
            }

            var completedFilterConfig = orderItemsGridSharedSettings.getCompletedFilter();
            if (completedFilterConfig) {
                $scope.showCompletedFilter = !!completedFilterConfig.enabled;
                var now = new Date();
                var oneMonthAgo = new Date();
                oneMonthAgo.setMonth(now.getMonth() - 1);
                $scope.datePickerFrom = completedFilterConfig.from || oneMonthAgo;
                $scope.datePickerTo = completedFilterConfig.to || now;
                $scope.showCompletedFilter = !!completedFilterConfig.enabled && $scope.step == 'all-open';
            } else {
                $scope.showCompletedFilter = false;
                $scope.datePickerFrom = null;
                $scope.datePickerTo = null;
            }
            completedDateChanged();
        }

        /**
         * Init the view title depending on the current user, current selected step
         * @returns {Promise}
         */
        function initTitle() {
            return $q.all([
                usersRepository.getCurrentUser(),
                workflowRepository.getSteps()
            ])
                .then(function (data) {
                    var currentUser = data[0];
                    var steps = data[1];

                    var currentStepCode = orderItemsGridSharedSettings.getStepFilter();

                    if (currentStepCode && currentStepCode !== "all-open") {
                        var isCustomer = currentUser.isCustomer();
                        var step = _.find(steps, function (s) {
                            return s.$model.code === currentStepCode;
                        });
                        var stepConfig = _.find($customisationConfig.workflow.steps, function (s) {
                            return s.code === currentStepCode;
                        });
                        var stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;

                        $scope.viewTitle = serverLocalization.translate(stepDisplayName);
                        $scope.viewIconName =
                            angular.isUndefined(stepConfig)
                                ? getFallbackIconForStep(step.$model.code)
                                : (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                                ? stepConfig.publicImageResourceName : (angular.isDefined(stepConfig.imageResourceName)
                                ? stepConfig.imageResourceName
                                : getFallbackIconForStep(step.$model.code)));

                        function getFallbackIconForStep(stepCode) {
                            return $customisationConfig.hasResource(function (res) {
                                return _.string.contains(res, stepCode + ".");
                            }) ? stepCode : "workflow";
                        }
                    } else {
                        $scope.viewTitle = gettextCatalog.getString("All Items");
                        $scope.viewIconName = "track";
                    }
                }, function (error) {
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error. Can't initialize grid title.");
                    }
                });
        }

        /**
         * Initialize grid
         * @returns {Promise}
         */
        function initGrid() {
            $q.all([
                gridDataProvider.getGridConfig($scope.step),
                templateResolver.resolve('app/ui/order/orderItemsGridView/orderItemsGrid/gridHeader.html')
            ]).then(function (data) {
                    var gridConfig = _.clone(data[0]);
                    var gridHeaderTemplate = data[1];
                    gridConfig = initGridConfig(gridConfig, gridHeaderTemplate);
                    gridConfig.dataSource = initGridDataSource(gridConfig);
                    $scope.gridConfig = gridConfig;

                    var gridTemplate = '<div kendo-grid="orderItemsGrid" k-options="gridConfig" class="all-open-grid k-grid-content"></div>';
                    var jqTemplate = $('#orderItemsKendoGrid').append(gridTemplate);
                    $compile(jqTemplate)($scope);
                },
                function (error) {
                    $log.error("Can't initialize grid: ");
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }

        function destroyGrid() {
            if (!$scope.orderItemsGrid || !$scope.orderItemsGrid.destroy) {
                return;
            }
            $scope.orderItemsGrid.destroy();
        }

        function initGridConfig(gConfig, gridHeaderTemplate) {
            if (gConfig.columns) {
                var firstVisibleColumn = _.find(gConfig.columns, function (c) {
                    return !c.hidden;
                });
                if (firstVisibleColumn) {
                    firstVisibleColumn.template = _.string.sprintf(
                        "<div style='white-space:nowrap;'><a title='%s' class='fa fa-lg fa-ellipsis-v a-fa-btn details-btn pull-left' ng-click='showStepDetails()'></a><span>#:%s#</span></div>",
                        gettextCatalog.getString("View Details"),
                        firstVisibleColumn.field);
                }
            }
            gConfig.sortable = {
                mode: "multiple",
                allowUnsort: true
            };
            gConfig.toolbar = [{template: gridHeaderTemplate}];

            gConfig.dataBound = function () {
                //double click event to allow user to open order details
                $("tbody[role='rowgroup'] [role='row']").on("dblclick", function () {
                    showStepDetails();
                });

                if ($scope.selectedOrderItemId) {
                    var dataItem = $scope.gridConfig.dataSource.get($scope.selectedOrderItemId);
                    if (dataItem && dataItem.uid) {
                        $scope.orderItemsGrid.select('tr[data-uid="' + dataItem.uid + '"]');
                    }
                }
            };
            gConfig.change = function () {
                var selected = getSelectedEntities();
                if (selected && selected[0] && selected[0].isRepresentationModel) {
                    $scope.selectedOrderItemId = selected[0].getId();
                    $scope.selectedOrderItem = selected[0];
                    orderItemsGridSharedSettings.setSelectedOrderItemId(selected[0].getId());

                    //we need to trigger dropdown list refresh so it will reevaluate its items templates (Kendo issue :( )
                    $scope.reportsDropDown.refresh();
                }
            };
            if (!gConfig.pageable || gConfig.pageable === true) {
                gConfig.pageable = {
                    refresh: true,
                    pageSizes: true
                };
            }
            return gConfig;
        }

        var forcedPageChange = false;
        var cachedResult;

        function initGridDataSource(gridConfig) {
            return new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        if (forcedPageChange) { // prevent data request after manual page change
                            forcedPageChange = false;
                            if (cachedResult) {
                                options.success(cachedResult);
                            } else {
                                toastr.error(gettextCatalog.getString("Data request cache error"));
                                options.error();
                            }
                            return;
                        }
                        $scope.isBusy = true;
                        orderItemsGridSharedSettings.setPageNumber(options.data.page || 1);
                        orderItemsGridSharedSettings.setPageSize(options.data.pageSize || 10);
                        orderItemsGridSharedSettings.setGridFilter(options.data.filter);
                        orderItemsGridSharedSettings.setGridSort(options.data.sort);

                        gridDataProvider.getData()
                            .then(function (result) {
                                // check if current page number was changed
                                if ($scope.gridConfig.dataSource.page() !== result.pageNumber ||
                                    $scope.gridConfig.dataSource.pageSize() !== result.rowsPerPage) {
                                    cachedResult = _.clone(result);
                                    forcedPageChange = true;
                                    options.page = result.pageNumber;
                                    options.pageSize = result.rowsPerPage;
                                    $scope.gridConfig.dataSource.query(options);
                                }
                                if (!$scope.selectedOrderItemId) {
                                    $scope.selectedOrderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();
                                }

                                var ts = orderItemsGridSharedSettings.getTextSearch();
                                if (result.totalCount === 1 && result.items.length === 1) { // if we found one item...
                                    if (ts && ts.text && textSearchTrigger === true) { // ...and search box is not empty...
                                        // ...open the item
                                        orderItemsGridSharedSettings.setSelectedOrderItemId(result.items[0].getId());
                                        $state.go('client.step', {
                                            step: $scope.step
                                        });
                                    }
                                } else if (result.totalCount == 0) { // if we found nothing
                                    // todo sound notification
                                    if (ts && ts.text) {
                                        // select search text box
                                        $($element).find("#gridTextSearchField").select();
                                    }
                                }

                                options.success(result);
                                $scope.isBusy = false;
                                textSearchTrigger = false;
                            }, function (resp) {
                                textSearchTrigger = false;
                                if (resp && resp.status) {
                                    toastr.error(resp.message, gettextCatalog.getString("Data request failed"));
                                } else {
                                    toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                                }
                                options.error();
                                $scope.isBusy = false;
                            });
                    }
                },
                schema: {
                    data: function (response) {
                        return response ? response.items : null;
                    },
                    total: function (response) {
                        return response ? response.totalCount : 0;
                    },
                    model: {
                        id: "$model.id",
                        fields: gridConfig.fields || {}
                    }
                },
                page: orderItemsGridSharedSettings.getPageNumber() || 1,
                pageSize: orderItemsGridSharedSettings.getPageSize() || gridConfig.pageSize || 10,
                filter: orderItemsGridSharedSettings.getGridFilter(),
                sort: orderItemsGridSharedSettings.getGridSort(),
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            });
        }

        /**
         * Initialize watchers (call only one time!)
         */
        function initWatchers() {

            $scope.$watch('datePickerFrom', completedDateChangedHandler);
            $scope.$watch('datePickerTo', completedDateChangedHandler);
            $scope.$watch('showCompletedFilter', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    if (newVal === true && !$scope.datePickerFrom && !$scope.datePickerTo) {
                        var now = new Date();
                        var oneMonthAgo = new Date();
                        oneMonthAgo.setMonth(now.getMonth() - 1);
                        $scope.datePickerFrom = oneMonthAgo;
                        $scope.datePickerTo = now;
                    }
                    completedDateChanged();
                    reloadGrid();
                }
            });
            initSignalREvents();

            $scope.$on(
                "$destroy",
                function () {
                    destroyGrid();
                    orderItemsGridControllerUpdatesService.onOrderItemChanged(null);
                    orderItemsGridControllerUpdatesService.onNewOrderItem(null);
                    orderItemsGridControllerUpdatesService.onOrderChanged(null);
                }
            );

            function completedDateChangedHandler(newVal, oldVal) {
                if (!_.isEqual(newVal, oldVal)) {
                    completedDateChanged();
                    if ($scope.showCompletedFilter === true) {
                        reloadGrid();
                    }
                }
            }
        }

        function initSignalREvents() {
            orderItemsGridControllerUpdatesService.onOrderItemChanged(function () {
                reloadGrid();
            });
            orderItemsGridControllerUpdatesService.onNewOrderItem(function () {
                reloadGrid();
            });
            orderItemsGridControllerUpdatesService.onOrderChanged(function () {
                reloadGrid();
            });
        }

        function completedDateChanged() {
            orderItemsGridSharedSettings.setCompletedFilter({
                from: $scope.datePickerFrom,
                to: $scope.datePickerTo,
                enabled: !!$scope.showCompletedFilter
            });
        }

        /**
         * Reports DropDown initialization
         * @returns {Promise}
         */
        function initReportList() {
            return reportManager.getReportList(orderItemsGridSharedSettings.getStepFilter())
                .then(function (results) {
                    var reportComboItems = [];
                    _.forEach(results, function (value) {
                        reportComboItems.push({
                            "text": value.name,
                            "value": value
                        });
                    });
                    $scope.dropdownReportsOptions = {
                        dataSource: reportComboItems,
                        dataTextField: "text",
                        dataValueField: "value",
                        valueTemplate: gettextCatalog.getString("Reports"),
                        template: "<span class='k-state-default'  # if (!!data.value.requiresSelection) { # ng-class='{\"k-state-disabled\": selectedOrderItemId == null}' # } #><span>{{dataItem.text|sTranslate}}</span></span>",
                        select: function (e) {
                            var report = $scope.dropdownReportsOptions.dataSource[e.item.index()]; //get the clicked report configuration
                            var gridQuery = gridDataProvider.getReportQuery(); //acquire the current query used to populate the grid
                            var selectedItemId = orderItemsGridSharedSettings.getSelectedOrderItemId(); //see if we have a selected item

                            if (!!report.value.requiresSelection) {
                                if (angular.isDefined(selectedItemId)) {
                                    //we use the selected item id as a query for the report if we have one selected
                                    reportManager.show({
                                        report: report.value,
                                        query: [selectedItemId],
                                        orderBy: report.value.orderBy || gridQuery.orderBy
                                    });
                                }
                                //do nothing if report requires selection and we don't have any item selected
                            } else {
                                //If report doesn't require selection, use either specific custom query of the report (report.value.query) 
                                //specified in customisation or just the query that is used to show the current data set (gridQuery.query) 
                                //user is being viewing at.
                                //Query and orderBy from report specified in customisation have higher priority over current-context data.
                                reportManager.show({
                                    report: report.value,
                                    //Now supply the query to the report manager. Here we check if the report was configured with static query,
                                    //dynamic (function) query or no query at all. If it is a dynamic query - we use it, otherwise we use static query.
                                    //In case no query was configured in the report configuration section, we just use the grid's query to generate
                                    //report for exactly the same items we see in the grid.
                                    query: angular.isFunction(report.value.query)
                                        ? report.value.query(gridQuery, $scope.selectedOrderItem)
                                        : (report.value.query || gridQuery.query),
                                    orderBy: report.value.orderBy || gridQuery.orderBy
                                });
                            }
                        },
                        dataBound: function () {
                            this.list.width('auto');
                        }
                    };
                }, function (error) {
                    $log.error("Can't initialize report list: ");
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }

        /**
         * Get selected items from grid
         * @returns {!RepresentationModel[]}
         */
        function getSelectedEntities() {
            var selectedEntities = [];
            var selectedDOM = $scope.orderItemsGrid.select();
            _.forEach(selectedDOM, function (value) {
                selectedEntities.push($scope.orderItemsGrid.dataItem(value));
            });
            return selectedEntities;
        }

        /**
         * Go to the Step Details View
         */
        function showStepDetails() {
            var selected = getSelectedEntities();
            if (!selected) {
                return;
            }
            var firstSelected = selected[0];
            if (firstSelected && firstSelected.isRepresentationModel) {
                orderItemsGridSharedSettings.setSelectedOrderItemId(firstSelected.getId());
                // go to the Step Details View
                $state.go('client.step', {
                    step: $scope.step
                });
            }
        }

        var textSearchTrigger = false;

        /**
         * Apply text search
         */
        function applyTextSearch() {
            orderItemsGridSharedSettings.setTextSearch($scope.textSearch, $scope.searchDropdown === "exact-search");
            reloadGrid();
            textSearchTrigger = true;
        }

        /**
         * Force grid to refresh (if loaded)
         */
        function reloadGrid() {
            if ($scope.orderItemsGrid && $scope.orderItemsGrid.dataSource && $scope.orderItemsGrid.dataSource.read) {
                $scope.orderItemsGrid.dataSource.read();
            }
        }

    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderItemsGridControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;